import { render, staticRenderFns } from "./NotificationPreview.vue?vue&type=template&id=7d524034"
import script from "./NotificationPreview.vue?vue&type=script&lang=ts"
export * from "./NotificationPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports